module.exports = __webpack_public_path__ + "static/AviaryAttorney0-3886e5415ecc550cfe2ee98ade10d7e9.webp";